import { PureComponent, ReactNode } from 'react';
import {
    LifestyleHabits,
    MEDICAL_HISTORY_CATEGORY,
    MHItem,
    PatientMedicalCondition,
} from '../../../store/types/medicalHistory';

interface Props {
    patientMedicalCondition?: PatientMedicalCondition[];
    patientLifeStyleHabits?: LifestyleHabits[];
    onClick?: () => void;
    showAll?: boolean;
}

export const getMergedMHResults = (
    patientMedicalCondition?: PatientMedicalCondition[],
    patientLifeStyleHabits?: LifestyleHabits[],
) => {
    const mergedResult: MHItem[] = [];
    patientMedicalCondition?.forEach((item) => {
        if (item?.status?.toLowerCase() === 'active') {
            mergedResult?.push({
                ...item,
                catId: MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS,
            });
        }
    });
    patientLifeStyleHabits?.forEach((item) => {
        if (item?.status?.toLowerCase() === 'active') {
            mergedResult?.push({ ...item, catId: MEDICAL_HISTORY_CATEGORY.LIFESTYLE_HABITS });
        }
    });
    return mergedResult;
};

class PatientMedicalSummary extends PureComponent<Props> {
    render(): ReactNode {
        const { patientMedicalCondition, onClick, patientLifeStyleHabits, showAll } = this.props;
        const mergedResult: MHItem[] = getMergedMHResults(
            patientMedicalCondition,
            patientLifeStyleHabits,
        );

        if (!mergedResult || mergedResult.length === 0) {
            return null;
        }

        const count = showAll ? mergedResult.length : 4;

        return (
            <div
                onClick={onClick}
                className={`flex flex-wrap items-center capitalize ${
                    onClick ? 'cursor-pointer' : 'cursor-auto'
                }`}
            >
                {mergedResult.map((item, i) =>
                    i < count ? (
                        <span
                            className={`max-w-99 text-center mt-8 mr-8 border 
                        ${
                            item.catId === MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS
                                ? 'border-status-warning text-status-warning bg-status-warningBG'
                                : 'border-darwin-primary-400 bg-white text-darwin-primary-400'
                        }
                         
                         text-12 px-8 py-2 rounded-4 inline-flex items-center chip-show`}
                        >
                            <p className="w-full truncate">{item.name}</p>
                        </span>
                    ) : null,
                )}

                {mergedResult.length > count && (
                    <p className="mt-8 mr-8 text-status-warning text-12 cursor-pointer">
                        &amp; {mergedResult.length - count} more
                    </p>
                )}
            </div>
        );
    }
}

export default PatientMedicalSummary;
